export default __webpack_public_path__ + "static/media/office-reverse.c181c5ef.mp4";